module.exports = __webpack_public_path__ + "img/agri.1e594ff5.jpg";